<script setup>
import NewFeeTabsPage from '@/components/operational/newFee/NewFeeTabsPage.vue'
import { readLastMaster, rememberLastMaster } from '@/components/operational/newFee/lastMasterSelection'
import { useFeeRuleSet } from '@/components/operational/newFee/useFeeRuleSet'

import FeeConfigurationContent from './components/FeeConfigurationContent.vue'

const route = useRoute()
const router = useRouter()
const readQueryString = key => (typeof route.query[key] === 'string' ? route.query[key] : '')
const selectedMasterId = computed(() => readQueryString('masterId'))
const selectedMasterLabel = computed(() => readQueryString('masterLabel'))
const selectedMasterName = computed(() => readQueryString('masterName'))

const { feeVersions, feeRuleSetId, feeRuleSetRoot, loading, load, reset } = useFeeRuleSet()

// 顶部 tab 切换不带 query：进入本页时若 query 里没有 masterId，就用上次记住的 Master 补回去
// 补回期间不执行 reset，避免先闪一下"请选择 Master"的空态
const lastMaster = selectedMasterId.value ? null : readLastMaster()
let isRestoringLastMaster = lastMaster !== null

if (lastMaster)
  router.replace({ query: { ...route.query, ...lastMaster } })

// 以选中的 Master 账号作为 ma_id 加载规则集；未选中则清空
// 首次进入 / 搜索框切换 Master 时显示 loading；Save Draft 等操作后的刷新静默进行
const loadMasterFeeRuleSet = ({ silent = false } = {}) => {
  if (!selectedMasterId.value) {
    if (!isRestoringLastMaster)
      reset()

    return
  }

  isRestoringLastMaster = false

  return load(selectedMasterId.value, { silent })
}

const refreshMasterFeeRuleSet = () => loadMasterFeeRuleSet({ silent: true })

watch(selectedMasterId, () => loadMasterFeeRuleSet(), { immediate: true })

// query 里有 Master 时记住它（搜索框选中 / 从 Platform fee 带过来 / 刷新恢复都会经过这里）
watch([selectedMasterId, selectedMasterLabel, selectedMasterName], ([masterId, masterLabel, masterName]) => {
  if (masterId)
    rememberLastMaster({ masterId, masterLabel, masterName })
}, { immediate: true })

// 搜索框选中 Master：写入路由 query，由上面的 watch 触发加载
const selectMaster = ({ value, label, holderName }) => {
  router.replace({
    query: {
      ...route.query,
      masterId: value,
      masterLabel: label,
      masterName: holderName,
    },
  })
}

definePage({
  name: 'operational-new-fee-master-fee',
  path: '/operational/newFee/master-fee',
  meta: {
    action: 'read',
    subject: 'Fee',
    navActiveLink: 'operational-new-fee',
  },
})
</script>

<template>
  <NewFeeTabsPage active-tab="master-fee">
    <FeeConfigurationContent
      show-master-search
      show-master-summary
      require-master-selection
      :loading="loading"
      :initial-master="selectedMasterId"
      :initial-master-label="selectedMasterLabel"
      :initial-master-name="selectedMasterName"
      :versions="feeVersions"
      :rule-set-id="feeRuleSetId"
      :rule-set-root="feeRuleSetRoot"
      @master-selected="selectMaster"
      @draft-saved="refreshMasterFeeRuleSet"
      @published="refreshMasterFeeRuleSet"
      @draft-created="refreshMasterFeeRuleSet"
    />
  </NewFeeTabsPage>
</template>
